
import React from "react";
import PmCheatSheet from '../Components/Dashboard/Resource-Center/PmCheatSheet';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
const AuthPmCheatSheet = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <PmCheatSheet /> : <SessionTimeoutRedirect />
}
export default AuthPmCheatSheet;


